// React
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// FutureLab
import { ModalConfirmation } from '../popup/modalConfirmation';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { useGetCurrentUserQuery, useLazyGetUserDetailsListQuery } from '../../store/api/userApi';
import { userListDetails } from '../../actions/userListDetailsActions';
import { loggedInUserDetails } from '../../actions/loggedInUserDetailsActions';

// 3rd Party
import _ from 'lodash';
import { store } from '../../ReduxRoot';

export default function WorkInProgressLogo() {
	const userListProfilesDetails = useSelector((state: RootState) => state.userListProfilesDetails);
	const loggedInUserDetail = useSelector((state: RootState) => state.loggedInUserDetails);
	const dispatch = useDispatch();
	const [displayModalConfirmation, setDisplayModalConfirmation] = React.useState<boolean>(false);
	const optionStore = { action: 'leavingFL' };
	const navigate = useNavigate();
	const { data: currentUser } = useGetCurrentUserQuery(undefined, { skip: !_.isEmpty(loggedInUserDetail) });
	const [loadUserDetailsList] = useLazyGetUserDetailsListQuery();

	useEffect(() => {
		if (_.isEmpty(loggedInUserDetail) && currentUser) {
			dispatch(loggedInUserDetails(currentUser));
		}
	}, [currentUser, dispatch, loggedInUserDetail]);

	const navigateToDashBoard = () => {
		window.open(`${process.env.REACT_APP_B2C_BASE_URL}`, '_blank');
		setDisplayModalConfirmation(!displayModalConfirmation);
	};

	const navigateToMentorDirectory = () => {
		window.open(`https://futurelab.my/discover/mentors`, '_blank');
		// setDisplayModalConfirmation(!displayModalConfirmation);
	};

	useEffect(() => {
		const loggedInUserId = loggedInUserDetail.id;
		if (_.isEmpty(store.getState().userListProfilesDetails) && loggedInUserId) {
			loadUserDetailsList([loggedInUserId])
				.unwrap()
				.then((users) => dispatch(userListDetails(users)));
		}
	}, [dispatch, loadUserDetailsList, loggedInUserDetail]);

	const userInfo = userListProfilesDetails.find(
		(userProfileDetails) => userProfileDetails.id === loggedInUserDetail.id
	);

	return (
		<div className="mx-auto h-full w-full min-w-0 overflow-y-auto px-4 py-6 md:max-w-6xl md:py-8">
			<div className="flex min-w-0 justify-center pb-3">
				<picture className="block w-full min-w-0">
					<source media="(min-width: 992px)" srcSet="../../../dashboard-banner-desktop.png" />
					<img alt="FutureLab dashboard" className="h-auto w-full max-w-full rounded-xl" src="../../../dashboard-banner.png" />
				</picture>
			</div>
			<div className="grid min-w-0 grid-cols-1 gap-4 md:grid-cols-3">
							{_.isEmpty(userInfo?.userRoles) ? (
								<button className="submit-session-feedback-button min-w-0 text-left" onClick={navigateToMentorDirectory} type="button">
										<span className="table-cell w-20 align-middle sm:w-24 pl-2 pr-3">
											<img
												src="../../../find-mentor.png"
												className="inline h-auto max-w-full rounded-2xl bg-blue-100 bg-opacity-30 p-3 sm:p-4"
												alt=""
											/>
										</span>
										<span className="table-cell break-words align-middle">Find A Mentor</span>
								</button>
							) : (
								<button className="submit-session-feedback-button min-w-0 text-left" onClick={() => navigate('feedback-session')} type="button">
										<span className="table-cell w-20 align-middle sm:w-24 pl-2 pr-3">
											<img
												src="../../../feedback-session.png"
												className="inline h-auto max-w-full rounded-2xl bg-blue-100 bg-opacity-30 p-3 sm:p-4"
												alt=""
											/>
										</span>
										<span className="table-cell break-words align-middle">Submit Session Feedback</span>
								</button>
							)}
							<button className="chat-button min-w-0 text-left" onClick={() => navigate('chat')} type="button">
								<span className="table-cell w-20 align-middle sm:w-24 pl-2 pr-3">
									<img
										src="../../../chat.png"
										className="inline h-auto max-w-full rounded-2xl bg-blue-100 bg-opacity-30 p-3 sm:p-4"
										alt=""
									/>
								</span>
								<span className="table-cell align-middle">Chat</span>
							</button>
							<button className="go-to-fl-button min-w-0 text-left" onClick={() => setDisplayModalConfirmation(true)} type="button">
						<span className="table-cell w-20 align-middle sm:w-24 pl-2 pr-3">
							<img
								src="../../../fl-dashboard.png"
								className="inline h-auto max-w-full rounded-2xl bg-blue-100 bg-opacity-30 p-3 sm:p-4"
								alt=""
							/>
						</span>
						<span className="table-cell break-words align-middle">Go to FL Dashboard</span>
							</button>
					{displayModalConfirmation && (
						<ModalConfirmation
							displayModalConfirmation={displayModalConfirmation}
							setDisplayModalConfirmation={setDisplayModalConfirmation}
							optionStore={optionStore}
							callBackProceedMethodProp={navigateToDashBoard}
						/>
					)}
			</div>
		</div>
	);
}
